import React, { Fragment } from 'react';

const SortCriteriaCompact = ({ sortCriteria }) => {
  const selectedOption = [
    ...sortCriteria.filter((sort) => sort.selected === true),
    {},
  ][0];
  return (
    <div className="columns sort-criteria-compact">
      <div className="form__select-wrapper ">
        <select
          value={selectedOption.value}
          className="form__input form__select sort-criteria-compact__select"
          aria-label="Sort"
          onChange={(event) => (window.location = event.target.value)}
        >
          {sortCriteria &&
            sortCriteria.map(({ text, value, selected }, index) => (
              <option value={value} key={`sorteriaCompact-${index}`}>
                {text}
              </option>
            ))}
        </select>
        <i className="smdicon-caret-down"></i>
      </div>
    </div>
  );
};

export default SortCriteriaCompact;
